export default "__VITE_PUBLIC_ASSET__4cd43e4a__"